import { Menu } from '@base-ui/react/menu';
import { Check, Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@resource-kit/ui';
import {
  Button,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@resource-kit/ui/react';
import { useLocale, SUPPORTED_LOCALES } from '@hooks/useLocale';

export default function LanguageSwitcher({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { locale, setLocale } = useLocale();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={<Button variant="ghost" size="icon" className={cn('shrink-0', className)} />}
        aria-label={t('language.switch')}
        title={t('language.switch')}
        data-testid="language-switcher"
      >
        <Languages size={18} aria-hidden="true" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <Menu.Group>
          {SUPPORTED_LOCALES.map(({ code, label }) => (
            <DropdownMenuItem
              key={code}
              role="menuitemradio"
              aria-checked={code === locale}
              onClick={() => setLocale(code)}
            >
              <Check size={16} className={cn(code !== locale && 'opacity-0')} aria-hidden="true" />
              {label}
            </DropdownMenuItem>
          ))}
        </Menu.Group>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
